export default __webpack_public_path__ + "assets/models/05da7b844b55c289182c6a8ed4eeba52.glb";